import { captureErrorInSentry } from 'lib/captureInSentry';
import isEmpty from 'lodash/isEmpty';
import getGAEvent, { Data } from './utils/getGAEvent';

const sendGAEvent = (data: Data): void => {
  try {
    const event = getGAEvent(data);

    if (typeof window === 'undefined' || isEmpty(event)) {
      return;
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push(event);
  } catch (error) {
    captureErrorInSentry(error);
  }
};

export default sendGAEvent;
